/**
 * Expands a flat content list into a versioned list.
 * Items with pending/rejected approvals produce a second "snapshot" card.
 */
export function buildVersionedList(items, idKey = 'id') {
  const result = [];
  for (const item of items) {
    result.push({ ...item, _viewType: 'live' });

    if (
      (item.approvalStatus === 'pending' || item.approvalStatus === 'rejected') &&
      item.proposedSnapshot
    ) {
      const snap = typeof item.proposedSnapshot === 'string'
        ? JSON.parse(item.proposedSnapshot)
        : item.proposedSnapshot;

      result.push({
        ...snap,
        approvalStatus:     item.approvalStatus,
        approvalId:         item.approvalId,
        approvalActionType: item.approvalActionType,
        _viewType:          'snapshot',
        _liveId:            item[idKey],
      });
    }
  }
  return result;
}

export function filterVersionedList(versionedItems, tab) {
  switch (tab) {
    case 'all':
      return versionedItems;

    case 'draft':
      return versionedItems.filter(i => i._viewType === 'live' && i.contentStatus === 'draft' && i.approvalStatus !== 'pending');

    case 'pending':
      return versionedItems.filter(i =>
        (i._viewType === 'snapshot' && i.approvalStatus === 'pending') ||
        (i._viewType === 'live' && i.approvalStatus === 'pending' && i.approvalActionType === 'create' && !i.proposedSnapshot)
      );

    case 'live':
      return versionedItems.filter(i => i._viewType === 'live' && i.contentStatus === 'approved');

    case 'rejected':
      return versionedItems.filter(i => i._viewType === 'snapshot' && i.approvalStatus === 'rejected');

    default:
      return versionedItems;
  }
}

export function countVersionedTabs(items, idKey = 'id') {
  const v = buildVersionedList(items, idKey);
  return {
    all:      v.length,
    draft:    filterVersionedList(v, 'draft').length,
    pending:  filterVersionedList(v, 'pending').length,
    live:     filterVersionedList(v, 'live').length,
    rejected: filterVersionedList(v, 'rejected').length,
  };
}
